import React from "react";
import { StyledDiv } from "./_.styled";
import { useEventBus } from "../../util/useEventBus";
import { Button, Icon } from "@ebscois/react-component-library";
import { logCheckInteractionsClicked } from "../../util/analytics";
import { CTA_TRIGGER_ACTION, useLaunchCTA } from "../../hooks/useLaunchCTA";

const CheckInteractionsButton = ({
  isDesktop,
  drugInteractionEvent,
  testId,
  telemetryData,
  isPreviewMode,
}) => {
  const eventBus = useEventBus();
  const { launchCTA } = useLaunchCTA({ eventBus });

  const handleClick = () => {
    if (isPreviewMode) {
      launchCTA({ userAction: CTA_TRIGGER_ACTION.CHECK_INTERACTIONS_CLICK });
    } else {
      eventBus.emit(
        drugInteractionEvent.eventName,
        null,
        drugInteractionEvent.eventProps
      );
      logCheckInteractionsClicked(telemetryData);
    }
  };

  const size = isDesktop ? "md" : "sm";

  return (
    <StyledDiv>
      <Button size={size} onClick={handleClick} data-testid={testId}>
        <Icon
          icon={{
            ...drugInteractionEvent.icon,
            size,
          }}
        />
        {drugInteractionEvent.label}
      </Button>
    </StyledDiv>
  );
};

CheckInteractionsButton.displayName = "CheckInteractionsButton";

export default CheckInteractionsButton;
